<template>
  <span
    class="badge line-clamp-1 flex items-baseline truncate"
    :class="badge_styles[status ?? '']?.class"
  >
    <i :class="badge_styles[status ?? '']?.ico"></i>
    {{ badge_styles[status ?? ""]?.text ?? "Không có thông tin" }}
  </span>
</template>

<script setup lang="ts">
const badge_styles: {
  [key: string]: { class: string; text: string; ico: string };
} = {
  running: {
    class: "badge-info",
    text: "Đang chạy",
    ico: "fa-solid fa-play",
  },
  terminated: {
    class: "badge-error",
    text: "Đã kết thúc",
    ico: "fa-solid fa-stop",
  },
  suspended: {
    class: "badge-warning",
    text: "Đã tạm dừng",
    ico: "fa-solid fa-circle-pause",
  },
  unknown: {
    class: "badge-neutral",
    text: "Không xác định",
    ico: "fa-solid fa-question",
  },
  "not responding": {
    class: "badge-error",
    text: "Không phản hồi",
    ico: "fa-solid fa-triangle-exclamation",
  },
};

defineProps<{
  status?: string;
}>();
</script>
